import React, { useContext, useEffect, useState } from "react";
import { Dropdown, Menu, Modal } from "antd";
import { logout } from "../../services/userServices";
import { AppContext } from "../../contexts/global";
import { graphql, navigate, useStaticQuery } from "gatsby";
import Wrapper from "../wrapper-permissions";
import FormHelp from "../forms/help";
import PoliticyTerms from "../politicy-terms";
import { getAllNotifications } from "../../services/appServices";
import { getStorage } from "../../utils/utils";
import { trackSessionDuration, trackButtonClick } from "../../utils/analytics";

export const HeaderActions = () => {
  const [isCount, setIsCount] = useState(0);
  const [response, setResponse] = useState(1);
  const [menu, setMenu] = useState();
  const [loginTime] = useState(Date.now());
  const {
    user,
    isView,
    count,
    setIsView,
    notifications,
    setNotifications,
    setCount,
    setUser,
  } = useContext(AppContext);
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const query = useStaticQuery(graphql`
    {
      allPrismicSettings {
        nodes {
          data {
            adminemail
            sendemail {
              text
            }
          }
        }
      }
      allPrismicTerms {
        nodes {
          data {
            text {
              richText
            }
          }
        }
      }
    }
  `);

  const terms = query.allPrismicTerms || [];
  const emailsAdmin = query.allPrismicSettings.nodes[0]?.data?.adminemail;
  const sendEmail = query.allPrismicSettings.nodes[0]?.data?.sendemail?.text;
  const modalTerms = () => {
    Modal.info({
      wrapClassName: "ant-modal-terms",
      icon: false,
      closable: true,
      content: <PoliticyTerms data={terms} />,
      okText: "Aceptar",
      onOk() {},
    });
  };

  const showModalHelp = () => {
    setOpenModalHelp(true);
  };

  const newNotification = (items) => {
    if (items.length > notifications) {
      setCount(items.length - notifications);
      if (!isView) {
        setCount(items.length);
      }
      setIsView(false);
      setNotifications(items.length);
    }
  };

  const notificationStorage = (items) => {
    let notifications = [];
    const storageItems = getStorage("items", true);
    if (storageItems && storageItems.length) {
      const userStorage = storageItems.find(
        (item) => item.username === user.sub
      );
      if (userStorage) {
        setNotifications(items.length);
        items.forEach((item) => {
          const filter = userStorage.ids.find((e) => e == item.id);
          if (!filter) {
            notifications.push(item);
            setNotifications(items.length);
            setIsView(userStorage.views);
          }
        });
        if (items.length > userStorage.cantidad) {
          const noti = items.length - userStorage.cantidad;
          setCount(noti);
          setIsView(false);
        }
      } else {
        notifications = items;
        newNotification(items);
      }
    } else {
      newNotification(items);
      notifications = items;
    }
    return notifications.sort((a, b) => b.id - a.id);
  };

  const getNotifications = async () => {
    if (user && user["token"]) {
      let itemsNotifications = await getAllNotifications(user["token"]);
      if (itemsNotifications && itemsNotifications.length === 0) {
        localStorage.removeItem("items");
        setNotifications(0);
      }
      if (itemsNotifications && itemsNotifications.length) {
        const items = notificationStorage(itemsNotifications);
        setIsCount(items.length);
        const getMenu = (
          <Menu
            onClick={(ev) => viewNotifications(ev.domEvent.target.id)}
            data-testid="btn-view-notification"
          >
            <div className="notifications">
              {items.map((item, index) => (
                <Menu.Item key={index}>
                  <a
                    href={`${process.env.URL_BASE_EDUKANDO_LABTICA_NEWS}${item.id}`}
                    target="_blank"
                    id={item.id}
                  >
                    <div className="notifications-title">{item.title}</div>
                  </a>
                </Menu.Item>
              ))}
            </div>
          </Menu>
        );
        setMenu(getMenu);
        setResponse(2);
      } else {
        setIsView(true);
      }
    }
  };
  const viewNotifications = async (id) => {
    if (notifications > 0) {
      const storageVistas = getStorage("items", true);
      let params = editStorage(storageVistas, id);
      localStorage.setItem("items", JSON.stringify(params));
      setResponse(1);
      setNotifications(notifications - 1);
      await getNotifications();
    }
  };
  useEffect(() => {
    if (response == 1) {
      getNotifications();
    }
  }, [notifications]);

  const editStorage = (storageVistas, isId) => {
    let noti = notifications;
    if (storageVistas && storageVistas.length) {
      return storageVistas.map((e) => {
        if (e.username === user.sub) {
          let params = {
            username: user.sub,
            views: true,
            cantidad: noti,
            ids: [...e.ids],
          };
          if (isId) {
            params["ids"] = [...e.ids, isId];
          }
          return params;
        } else {
          return e;
        }
      });
    } else {
      return [
        {
          username: user.sub,
          views: true,
          cantidad: noti,
          ids: [],
        },
      ];
    }
  };
  const createStorage = (storageVistas) => {
    const newStorage = {
      username: user.sub,
      views: true,
      cantidad: notifications,
      ids: [],
    };
    return [...storageVistas, newStorage];
  };

  const onView = (ev) => {
    ev.preventDefault();
    let params = [
      {
        username: user.sub,
        views: true,
        cantidad: 0,
        ids: [],
      },
    ];
    const storageVistas = getStorage("items", true);
    if (storageVistas && storageVistas.length) {
      const findStorage = storageVistas.find((e) => e.username === user.sub);
      if (findStorage) {
        params = editStorage(storageVistas);
      } else {
        params = createStorage(storageVistas);
      }
    }
    setNotifications(0);
    if (count > 0) {
      setNotifications(notifications);
      params[0].cantidad = notifications;
    }
    localStorage.setItem("items", JSON.stringify(params));
    setIsView(true);
  };

  const userNav = (
    <Menu>
      <Menu.Item key="0" id="menu.perfil">
        <a data-testid='btn-perfil' onClick={() => navigate("/perfil")}>
          <em className="fa-solid fa-user" /> Mi perfil
        </a>
      </Menu.Item>
      <Wrapper
        element={
          <Menu.Item key="1" id="menu.admin">
            <a
              onClick={() => navigate("/administrador")}
              data-testid="btn-admin"
            >
              <em className="fa-solid fa-user-gear" /> Administrar
            </a>
          </Menu.Item>
        }
      />

      <Menu.Item key="3" id="menu.ayuda">
        <a data-testid='btn-help' onClick={showModalHelp}>
          <em className="fa-solid fa-life-ring" /> Ayuda
        </a>
      </Menu.Item>

      <Menu.Item key="3" id="menu.ayuda">
        <a data-testid='btn-terms' onClick={modalTerms}>
          <em className="fa-solid fa-file-circle-exclamation" /> Política de
          privacidad, términos y condiciones
        </a>
      </Menu.Item>

      <Menu.Divider />
      <Menu.Item
        key="4"
        id="menu.cerrar"
        data-testid='btn-cerrar'
        onClick={() => {
          const sessionDuration = Math.floor((Date.now() - loginTime) / 1000);
          trackSessionDuration(sessionDuration);
          trackButtonClick('logout', 'header_menu');
          logout();
          setUser({});
        }}
      >
        <div>
          <em className="fa-solid fa-arrow-right-from-bracket" /> Cerrar sesión
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <AppContext.Consumer>
        {(theme) => (
          <div className="ant-layout-header-actions">
            <Dropdown
              overlay={userNav}
              trigger={["click"]}
              data-testid='dropdown'
              overlayClassName="default"
            >
              <div className="profile-dd" onClick={(e) => e.preventDefault()} data-testid='click-dropdown'>
                <div className="profile-dd-image">
                  <img
                    src={theme.user?.picture}
                    className={theme.user?.picture ? "show" : "hide"}
                  />
                  <em
                    className={`fa-solid fa-user ${
                      theme.user?.picture && "hide"
                    }`}
                  />
                </div>
                <div className="profile-dd-name">
                  <strong>{!!theme.user.name && theme.user.name}</strong>
                  <span>
                    {!!theme.user["custom:position"] &&
                      theme.user["custom:position"]}
                  </span>
                </div>
              </div>
            </Dropdown>
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              overlayClassName="default"
              disabled={isCount > 0 ? false : true}
            >
              <div
                className={!isView ? "notifications active" : ""}
                onClick={onView}
                data-testid="btn-onview"
              >
                <div className="number">{!isView ? count : ""}</div>
                <em className="fa-solid fa-bell" />
              </div>
            </Dropdown>
          </div>
        )}
      </AppContext.Consumer>

      <FormHelp
        visible={openModalHelp}
        onClose={() => {
          setOpenModalHelp(!openModalHelp);
        }}
        data={{ emailsAdmin, sendEmail }}
      />
    </>
  );
};
